import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);
//Site Settings 
export const siteSettingsAPI = {
  getAll: async () => { 
    try {
      const response = await apiClient.get('/site_settings');
      console.log('Site Settings response:', response.data.data);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching site settings:', error);
      return [];
    }
  },
  
};

// Services API
export const servicesAPI = {
  getAll: async () => {
    try {
      const response = await apiClient.get('/industries');
      console.log('Services response:', response.data.data);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching services:', error);
      return [];
    }
  },
  
  getById: async (serviceId) => {
    try {
      const response = await apiClient.get(`/industries/${serviceId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching service:', error);
      return null;
    }
  }
};

// Jobs API
export const jobsAPI = {
  getAll: async (params = {}) => {
    try {
      const response = await apiClient.get('/jobs', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching jobs:', error);
      return { jobs: [], total: 0, page: 1, limit: 10 };
    }
  },
  
  getById: async (jobId) => {
    try {
      const response = await apiClient.get(`/jobs/details/${jobId}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching job:', error);
      return null;
    }
  },
  
  applyNow: async (jobData) => {
    try {
      const response = await apiClient.post('/job_seekers/create', jobData);
      return response.data;
    } catch (error) {
      console.error('Error creating job:', error);
      throw error;
    }
  },
  hireNow: async (jobData) => {
    try {
      const response = await apiClient.post('/hiring_requests/create', jobData);
      return response.data;
    } catch (error) {
      console.error('Error creating job:', error);
      throw error;
    }
  },
  
  
//   update: async (jobId, jobData) => {
//     try {
//       const response = await apiClient.put(`/jobs/${jobId}`, jobData);
//       return response.data;
//     } catch (error) {
//       console.error('Error updating job:', error);
//       throw error;
//     }
//   },
  
//   delete: async (jobId) => {
//     try {
//       const response = await apiClient.delete(`/jobs/${jobId}`);
//       return response.data;
//     } catch (error) {
//       console.error('Error deleting job:', error);
//       throw error;
//     }
//   }
};

// Applications API
// export const applicationsAPI = {
//   create: async (applicationData) => {
//     try {
//       const response = await apiClient.post('/applications', applicationData);
//       return response.data;
//     } catch (error) {
//       console.error('Error creating application:', error);
//       throw error;
//     }
//   },
  
//   getByCandidate: async (email) => {
//     try {
//       const response = await apiClient.get(`/applications/candidate/${email}`);
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching candidate applications:', error);
//       return [];
//     }
//   },
  
//   getByJob: async (jobId) => {
//     try {
//       const response = await apiClient.get(`/applications/job/${jobId}`);
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching job applications:', error);
//       return [];
//     }
//   },
  
//   getById: async (applicationId) => {
//     try {
//       const response = await apiClient.get(`/applications/${applicationId}`);
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching application:', error);
//       return null;
//     }
//   },
  
//   updateStatus: async (applicationId, status) => {
//     try {
//       const response = await apiClient.put(`/applications/${applicationId}/status`, { status });
//       return response.data;
//     } catch (error) {
//       console.error('Error updating application status:', error);
//       throw error;
//     }
//   }
// };

// Contact API
export const contactAPI = {
  careerConsultation: async (contactInfo, details) => {
    try {
      const response = await apiClient.post('/contact/career-consultation', {
        contact_info: contactInfo,
        details
      });
      return response.data;
    } catch (error) {
      console.error('Error submitting career consultation:', error);
      throw error;
    }
  },
  
  resumeSubmission: async (contactInfo, details) => {
    try {
      const response = await apiClient.post('/contact/resume-submission', {
        contact_info: contactInfo,
        details
      });
      return response.data;
    } catch (error) {
      console.error('Error submitting resume:', error);
      throw error;
    }
  },
  
  employerPartnership: async (contactInfo, details) => {
    try {
      const response = await apiClient.post('/contact/employer-partnership', {
        contact_info: contactInfo,
        details
      });
      return response.data;
    } catch (error) {
      console.error('Error submitting employer partnership:', error);
      throw error;
    }
  },
  
  legalConsultation: async (contactInfo, details) => {
    try {
      const response = await apiClient.post('/contact/legal-consultation', {
        contact_info: contactInfo,
        details
      });
      return response.data;
    } catch (error) {
      console.error('Error submitting legal consultation:', error);
      throw error;
    }
  }
};

// Testimonials API
export const testimonialsAPI = {
  getAll: async () => {
    try {
      const response = await apiClient.get('/testimonials'); 
      console.log('Testimonials response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      return [];
    }
  },
  
//   create: async (testimonialData) => {
//     try {
//       const response = await apiClient.post('/testimonials', testimonialData);
//       return response.data;
//     } catch (error) {
//       console.error('Error creating testimonial:', error);
//       throw error;
//     }
//   }
};

// Health check
export const healthAPI = {
  check: async () => {
    try {
      const response = await apiClient.get('/');
      return response.data;
    } catch (error) {
      console.error('Error checking API health:', error);
      return null;
    }
  }
};
const api = {
  services: servicesAPI,
  jobs: jobsAPI,
  siteSettings: siteSettingsAPI,
//   applications: applicationsAPI,
  contact: contactAPI,
  testimonials: testimonialsAPI,
  health: healthAPI
};
export default api;